export const environment = {
  production: false,
  msalConfig: {
    clientID: 'a7d6404d-1514-4456-af0a-945bc9e1e428',
    authority: 'https://login.microsoftonline.com/euromaster.onmicrosoft.com/',
    cacheLocation: 'localStorage',
    redirectUri: 'http://localhost:4200/',
    postLogoutRedirectUri: 'http://localhost:4200/',
    protectedResourceMap: "https://localhost:44365/",
    consentScopes: ['user.read'],
    resourceScope: 'api://a7d6404d-1514-4456-af0a-945bc9e1e428/user_impersonation',
  },
  parts_service_url: 'https://localhost:44340/api/',
  ADMIN_API_URL: 'https://localhost:44365/api/',
  currentenvironment: 'EM'
};